<script lang="ts">
    import { cx } from '$lib/utils/cx.js';
    import { TAG_ICONS } from './Utils';
    import * as t from '$trans';
    import type { FeedPostTagEnum } from '$gql/graphql';
    import { getContainer } from '$components/Context/ContainerContext';

    const { lang } = getContainer();

    export let tag: FeedPostTagEnum;
    export let className: string = '';

    $: icon = TAG_ICONS[tag];
    $: label = t.feed_post.select_tag({ tag }, $lang);
</script>

<div
    class={cx(
        'text-11/[120%]',
        'text-brand-blue',
        'font-medium',
        'px-[8px] py-[6px]',
        'rounded-[8px]',
        'bg-gray-100',
        'border border-solid border-gray-150',
        'flex items-center justify-center gap-x-[6px]',
        className,
    )}
>
    {#if icon != null}
        <i class={cx(icon, 'text-12')} aria-hidden={true} />
    {/if}
    <span>{label}</span>
</div>
